"use client"

import { POSTHOG_SIGNUP_PAGE_LOADED_EVENT } from "@/lib/posthog/identity"
import type { SignupExperimentVariant } from "@/lib/posthog/signupExperiment.constants"
import { useEffect } from "react"
import { usePostHog } from "posthog-js/react"

export function SignUpPageLoadTracker({ signupExperimentKey, signupExperimentVariant }: { signupExperimentKey?: string; signupExperimentVariant?: SignupExperimentVariant }) {
  const posthog = usePostHog()

  useEffect(() => {
    posthog.capture(POSTHOG_SIGNUP_PAGE_LOADED_EVENT, {
      page: "sign_up",
      signupExperimentKey,
      signupExperimentVariant,
    })
  }, [posthog, signupExperimentKey, signupExperimentVariant])

  return null
}
